/* eslint-disable */
import moment from 'moment';
import {
	useEffect, useMemo, useState
} from 'react';
import { connect } from 'react-redux';
// import { useHistory } from 'react-router';
// eslint-disable-next-line import/no-extraneous-dependencies
import analyticsAction from '../../../../Actions/analytics.actions';
// eslint-disable-next-line import/no-cycle
import { ProductImagesResult } from '../../../../Components/Analytics/Product';
import ImagesFinder from '../../../../Components/ImagesFinder/ImagesFinder';
import { DefectImageModal, RetagModal } from '../../../../Components/Modals';
// import { useQuery } from '../../../../Helpers';
import defectAnalyticsServices from '../../../../Services/Analytics Services/defect-analytics.services';
import productAnalyticsServices from '../../../../Services/Analytics Services/product-analytics.services';
import { liveQCServices } from '../../../../Services/LiveQC';
import styles from './ProductImagesPage.module.scss';
import { productActions } from '../../../../Actions';
import StickyLegends from '../../../../Components/MySticky/StickyLegends/StickyLegends';
import { useAuth } from '../../../../Components/Auth/Login/auth';
import { notificationServices } from '../../../../Services';
import myMachineService from '../../../../Services/AssetServices/myMachine.service';
import {
	BookmarkCheck,
	CheckCircle2,
	Filter,
	Send,
} from 'lucide-react';
import { Button } from '@mui/material';
import drawerActions from '@/Actions/drawer.actions';
import { filtersInfoChip } from '@/Helpers';
import { SelectPicker } from 'rsuite';

// const source =
// 'https://www.thespruceeats.com/thmb/vJUFf6L4p8y9Cn_1pE9Z7Ua9uok=/3000x2001/filters:fill(auto,1)/indian-style-burger-1957599-hero-01-266103a4bb4e4ee7b5feb4da2d2e99da.jpg';

export const legendWithColors = {
	egaPercentage: {
		color: '#9AC8CD',
		label: 'EGA %',
		suffix: '%',
	},
	minWeight: {
		color: '#8DECB4',
		label: 'Ideal Weight',
		hasUnit: true,
	},
	weight: {
		color: '#ECCA9C',
		label: 'Weight',
		hasUnit: true,
	},
	confidence: {
		color: '#E59BE9',
		label: 'Confidence',
	},
};

const cvatStatusLegend = [
	{
		label: 'CVAT eligible',
		Icon: CheckCircle2,
		className: 'border-emerald-200 bg-emerald-50 text-emerald-700',
	},
	{
		label: 'Queued for CVAT',
		Icon: BookmarkCheck,
		className: 'border-yellow-200 bg-yellow-50 text-yellow-800',
	},
	{
		label: 'Sent to CVAT',
		Icon: Send,
		className: 'border-blue-200 bg-blue-50 text-blue-700',
	},
];


const ProductImagesPage = (props) => {
	const [filters, setFilters] = useState({
		store: null,
		processTypes: null,
		brand: null,
		products: [],
		vendors: [],
		conf: 1,
		egaPercentage: undefined,
		productCategories: [],
		identification: 'Both',
		submissions: 0,
		timeType: {
			value: '',
			label: '',
		},
		dateRange: {
			active: false,
			from: new Date(),
			to: new Date(),
		},
		customExclusiveFilters: {},
		skuType: '',
	});
	const { clientType } = JSON.parse(localStorage.getItem('appConfig'));
	const { appConfig = {} } = useAuth();
	const { measurement } = appConfig?.configs ?? {};
	const isUS = measurement === 'US';
	const {
		allProductResults,
		fetchProductImages,
		updateProductImagesList,
		allDefectResults,
		fetchProducts,
		resetProductImages,
		userPermissions,
		updateDefectImagesList,
		toggleFiltersDrawer,
	} = props;
	// const query = useQuery();

	useEffect(() => {
		resetProductImages();
	}, []);

	const [loading, setLoading] = useState(false);
	const [pageLimit, setPageLimit] = useState(6);
	// eslint-disable-next-line no-unused-vars
	const [defaultState, _] = useState({
		DATE_RANGE: {
			active: true,
			from: new Date(),
			to: new Date(),
		},
	});

	const [machinesList, setMachineList] = useState([]);

	const handleListFetch = async ({ store = null }) => {
		// setIsloading(true);
		try {
			const responseData =
					await myMachineService.fetchListOfMachines({
						req: {
							data: {
								storeId: store?.id === -999 ? null : store?.id,
							},
						},
					});
			if (responseData?.statusCode === 200) {
				setMachineList(responseData?.data?.machinesList);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	useEffect(() => {
		handleListFetch({});
	}, []);

	const submitFindRequest = (incomingData) => {
		const {
			store = null,
			processTypes = null,
			brand,
			products = [],
			productCategories = [],
			identification,
			conf,
			egaPercentage = undefined,
			timeType,
			vendors = [],
			dateRange = {},
			customExclusiveFilters = {},
			skuType,
		} = incomingData;
		resetProductImages();
		setFilters({
			store,
			processTypes,
			brand,
			products,
			productCategories,
			vendors,
			egaPercentage,
			identification,
			conf: userPermissions.INTERNAL ? conf : 1,
			submissions: filters.submissions + 1,
			timeType,
			dateRange,
			customExclusiveFilters,
			skuType,
		});
		const data = {
			storeId: store?.id,
			brandId: brand?.id,
			processTypes: processTypes?.id,
			products: products?.id,
			vendors: vendors?.id,
			egaPercentage,
			productCategories: productCategories?.id,
			identification,
			qcType: 'PRODUCTION',
			skuType : skuType.toUpperCase(),
			conf: userPermissions.INTERNAL ? conf : 1,
			type: 'IDENTITY',
			machineIds: customExclusiveFilters?.id?.includes(-999)
				? null
				: customExclusiveFilters?.id,
			dateRangeFilter: dateRange?.active
				? {
					timeType : timeType?.value,
					from: moment(dateRange.from).format('YYYY-MM-DD'),
					to: moment(dateRange.to).format('YYYY-MM-DD'),
				}
				: {},
		};
		fetchProductImages({
			entity:
				clientType === 'SCHOOL'
					? 'DEFECT_ANALYSIS'
					: 'AI_PRODUCTION_ANALYSIS',
			method:
				clientType === 'SCHOOL' ? 'FIND_DEFECT_IMAGES' : 'FIND_IMAGES',
			req: {
				params: {
					limit: pageLimit,
				},
				data,
			},
		});
	};

	const fetchQCData = async (qcId) => {
		try {
			const req = {
				params: {
					qcId,
				},
			};

			const { data = null } = await liveQCServices.getPastData(req);

			return data;
		} catch {
			return null;
		}
	};

	const fetchProductImagesById = async (
		{
			page, productId, identification, typeRefresh = false, limit, machineIds,
		},
		index
	) => {
		if (clientType !== 'SCHOOL') {
			const response =
				await productAnalyticsServices.findProductImagesById({
					params: {
						page,
						limit: typeRefresh ? limit : pageLimit,
					},
					data: {
						storeId: filters.store?.id,
						productId,
						processTypes: filters.processTypes?.id,
						products: filters.products?.id,
						brandId: filters.brand?.id,
						conf: filters.conf,
						...(filters.egaPercentage > -1 && {
							egaPercentage: filters.egaPercentage,
						}),
						vendors: filters.vendors?.id,
						productCategories: filters.productCategories?.id,
						identification,
						qcType: 'PRODUCTION',
						type: 'IDENTITY',
						machineIds:
							filters?.customExclusiveFilters?.id,
						dateRangeFilter: filters.dateRange?.active
							? {
								timeType: filters?.timeType?.value,
								from: moment(filters.dateRange.from).format(
									'YYYY-MM-DD'
								),
								to: moment(filters.dateRange.to).format(
									'YYYY-MM-DD'
								),
							}
							: {},
					},
				});

			const { data = [] } = response;
			updateProductImagesList(index, data, typeRefresh);
			if (typeRefresh) {
				setLoading(false);
			}
			return data;
		}
		const response = await defectAnalyticsServices.findDefectImagesById({
			params: {
				page,
				limit: typeRefresh ? limit : pageLimit,
			},
			data: {
				storeId: filters.store?.id,
				labelId: productId,
				products: filters.products?.id,
				brandId: filters.brand?.id,
				vendors: filters.vendors?.id,
				productCategories: filters.productCategories?.id,
				identification,
				type: 'QUALITY',
				conf: filters.conf,
				machineIds,
				dateRangeFilter: filters.dateRange?.active
					? {
						timeType: filters?.timeType?.value,
						from: moment(filters.dateRange.from).format(
							'YYYY-MM-DD'
						),
						to: moment(filters.dateRange.to).format(
							'YYYY-MM-DD'
						),
					}
					: {},
			},
		});

		const { data = [] } = response;
		updateDefectImagesList(index, data, typeRefresh);
		if (typeRefresh) {
			setLoading(false);
		}
		return data;
	};

	useEffect(() => {
		fetchProducts({
			params: {
				id: '',
				skuType: 'PRODUCT',
				brandId: '',
			},
		});
	}, []);

	const totalValues = useMemo(() => {
		let totalShown = 0;
		let typeOfProducts = 0;
		let totalCount = 0;
		allProductResults?.forEach((product) => {
			if (product?.Annotation.length > 0) {
				totalShown += product?.Annotation?.length ?? 0;
				typeOfProducts++;
			}
			totalCount += product?.count ?? 0;
		});
		return {
			totalShown,
			totalCount,
			typeOfProducts,
		};
	}, [allProductResults]);

	const displayLegendsValues = (key, value) => {
		if (
			(filters?.egaPercentage > -1 && key !== 'confidence') ||
			(key === 'confidence' && userPermissions.INTERNAL)
		) {
			return {
				color: value?.color, label: value?.label,
			};
		}
		return {};
	};

	useEffect(() => {
		notificationServices.generateNotification({
			type: 'wave',
			message: 'Search with product for faster result',
		});
	}, []);

	const filtersInfo = {
		header : {
			store : false,
			statusAndTypes : false,
			product : false,
			date : false,
			process : false,
		},
		store : {
			text : 'Store',
			show : true,
		},
		processType: {
			text : 'Process Type',
			show : true,
		},
		skuType: {
			text : 'SKU Type',
			show : true,
		},
		product : {
			text : 'Product',
			show : true,
		},
		productCategory : {
			text : 'Product Category',
			show : true,
		},
		identificationType : {
			text : 'Identification Type',
			show : true,
		},
		confidence : {
			text : 'Confidence',
			show : true,
		},
		egaPercentage : {
			text : 'EGA Percentage',
			show : true,
		},
		dateRange : {
			text : 'Date Range',
			show : true,
		},
		customExclusiveFilters : {
			text : 'Machine Name',
			show : true,
			multiSelect: true,
			filterList: [{
				value: -999, label: 'ALL',
				}].concat(
				machinesList?.map((ele) => {
				return {
					value: ele.id,
					label: ele.machine_name + (ele?.storeName ? '(' + ele?.storeName + ')' : ''),
				};
			})),
		},
		timeType : {
			text : 'Date Time Type',
			show : true,
		},
	}

	const exportInfo = {
		hideExportAccordian : true,
	};

	return (
		<div className={styles.root}>
			<RetagModal
				handleSubmit={({ labelId, functionToExecute }) => {
					// validate(false, labelId);
					functionToExecute(labelId);
				}}
				skuType='PRODUCT'
			/>
			<DefectImageModal />
			<ImagesFinder
				isInternal={userPermissions.INTERNAL}
				onSubmit={submitFindRequest}
				defaultState={defaultState}
				setParentFilterState={(state) => {
					if (state?.store?.id !== -999) {
						handleListFetch({
							store: state.store?.id,
						});
					} else {
						handleListFetch({});
					}
				}}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className='flex justify-between m-4 '>
				<span className='font-bold text-[16px]'>Production Images </span>
				<Button
					onClick={() => {
						toggleFiltersDrawer(true);
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span>Filter</span>
					<Filter className='size-4' />
				</Button>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className='flex items-center gap-2'>
				<span>
					Page Limit : 
				</span>
				<SelectPicker
					data={[6, 25, 50, 100].map((item) => ({
						label: item,
						value: item,
					}))}
					value={pageLimit}
					onChange={(value) => setPageLimit(value)}
					searchable={false}
					className='w-[200px]'
				/>
			</div>
			{allProductResults?.length !== 0 && (
				<div className={styles.numbers}>
					<div className={styles.element}>
						Total Count:
						<span>{totalValues?.totalCount}</span>
					</div>
					<div className={styles.element}>
						Type of Products:
						<span>{totalValues?.typeOfProducts}</span>
					</div>
				</div>
			)}
			<StickyLegends
				getValueFunction={displayLegendsValues}
				legendKeyValues={legendWithColors}
			/>
			{userPermissions.INTERNAL && clientType !== 'SCHOOL' && (
				<div className='mx-4 flex flex-wrap items-center gap-3 rounded-md border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-700'>
					<span className='text-slate-500'>CVAT</span>
					{cvatStatusLegend.map(({ label, Icon, className }) => {
						return (
							<div key={label} className='flex items-center gap-1.5'>
								<span
									className={`flex h-6 w-6 items-center justify-center rounded-md border ${className}`}
								>
									<Icon size={15} strokeWidth={2.2} />
								</span>
								<span>{label}</span>
							</div>
						);
					})}
				</div>
			)}
			<div className={styles['image-results']}>
				{clientType === 'SCHOOL' &&
					allDefectResults.map((product, index) => {
						return (
							product.Annotation.length > 0 && (
								<ProductImagesResult
									refreshLoading={loading}
									setRefreshLoading={setLoading}
									isInternal={userPermissions.INTERNAL}
									// eslint-disable-next-line react/no-array-index-key
									key={`${product.id}${filters.submissions}${index}`}
									identification={filters.identification}
									fetchQCData={fetchQCData}
									fetchProductImagesById={(req) => {
										return fetchProductImagesById(
											req,
											index
										);
									}}
									product={product}
								/>
							)
						);
					})}
				{clientType !== 'SCHOOL' &&
					allProductResults.map((product, index) => {
						return (
							product.Annotation.length > 0 && (
								<ProductImagesResult
									refreshLoading={loading}
									setRefreshLoading={setLoading}
									isInternal={userPermissions.INTERNAL}
									// eslint-disable-next-line react/no-array-index-key
									key={`${product.id}${filters.submissions}${index}`}
									identification={filters.identification}
									fetchQCData={fetchQCData}
									isUS={isUS}
									egaPercentageSelected={
										filters?.egaPercentage > -1
									}
									fetchProductImagesById={(req) => {
										return fetchProductImagesById(
											req,
											index
										);
									}}
									product={product}
									machineIds={
										filters?.customExclusiveFilters?.id
									}
								/>
							)
						);
					})}
				{(clientType !== 'SCHOOL'
					? allProductResults
					: allDefectResults
				).length === 0 && (
					<p className={styles.fallback}>No items to display</p>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { FIND_IMAGES: allProductResults = {} } =
		state?.analytics?.AI_PRODUCTION_ANALYSIS;
	const { FIND_DEFECT_IMAGES: allDefectResults = {} } =
		state?.analytics?.DEFECT_ANALYSIS;
	const { userPermissions = {} } = state?.navigation;
	return {
		userPermissions,
		allProductResults,
		allDefectResults,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchProductImages: (...args) => {
			dispatch(analyticsAction.gateway(...args));
		},
		updateProductImagesList: (...args) => {
			dispatch(analyticsAction.updateProductImagesList(...args));
		},
		updateDefectImagesList: (...args) => {
			dispatch(analyticsAction.updateDefectImagesList(...args));
		},
		resetProductImages: () => {
			dispatch(analyticsAction.resetProductImages());
		},
		fetchProducts: (...args) => {
			dispatch(productActions.fetchProducts(...args));
		},
		toggleFiltersDrawer: (...args) => {
			dispatch(drawerActions.toggleFiltersDrawer(...args));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductImagesPage);
